// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { setTalkingPoints } from './talking-points.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const talkingPoints = createReducer({}, on(setTalkingPoints, (state, action) => {
    return action.talkingPoints;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
